<template>
    <div>
        <div class="product-seal product-seal-dark"
             v-if="product.promo_combo > 0 && showPromo">
            {{ product.promo_name }}
        </div>

        <!--todo-->
        <div class="product-seal product-seal-black"
             v-else-if="product.promo_combo === 25 && showPromo">
            <span class="text-uppercase hidden-xs">Black Friday</span>
            <i class="icon-cr icon-logo white hidden-xs"></i>
            <span>{{ product.promo_name }}</span>
        </div>

        <div class="product-seal product-seal-dark"
             v-else-if="showDiscount && product.discount && $scope.IS_REGULAR_CUSTOMER">
            {{ product.discount }}% OFF
        </div>

        <div class="product-seal product-seal-new text-uppercase"
             v-else-if="product.is_new && !product.promo_combo">
            {{ [5, 6, 8, 10, 14, 18, 31, 32, 36, 38, 42].indexOf(product.type.id) !== -1 ? 'Novo' : 'Nova' }}!
        </div>
    </div>
</template>

<script>
    export default {
        name: "ProductListItemSeal",

        props: {
            product: {
                type: Object,
                required: true
            },
            showDiscount: {
                type: Boolean,
                required: true
            },
            showPromo: {
                type: Boolean,
                required: true
            },
        }
    }
</script>